module.exports = __webpack_public_path__ + "img/banner_new.416f4a47.png";